export const phoneNumberValidator = (control: any) => {
	if (!control.value) return;
  
	const el: HTMLElement = control.nativeElement as HTMLElement;
	const inputBox: HTMLInputElement | any = el
	  ? el.querySelector('input[type="tel"]')
	  : undefined;  
	if (inputBox) {
	  const id = inputBox.id;
	  const isCheckValidation = inputBox.getAttribute('validation');
	  if (isCheckValidation === 'true') {
		const isRequired = control.errors && control.errors.required === true;
		const error = { validatePhoneNumber: { valid: false } };
  
		inputBox.setCustomValidity('Invalid field.');
  
		let number: any;
		const libPhone = (window as any).libphonenumber;
		if (!libPhone) {
		  console.warn('⚠️ libphonenumber-js is not loaded!');
		  return error;
		}
  
		try {
		  number = libPhone.parsePhoneNumber(
			control.value.number,
			control.value.countryCode.toUpperCase()
		  );
		} catch (e) {
		  if (isRequired) {
			return error;
		  } else {
			inputBox.setCustomValidity('');
		  }
		}
  
		if (control.value) {
		  if (!number) {
			return error;
		  } else {
			const isValid = libPhone.isValidNumberForRegion(
			  control.value.number,
			  control.value.countryCode.toUpperCase()
			);
  
			if (!isValid) {
			  return error;
			} else {
			  inputBox.setCustomValidity('');
			}
		  }
		}
	  } else if (isCheckValidation === 'false') {
		inputBox.setCustomValidity('');
		control.clearValidators();
	  }
	}
	return;
  };
  